import { render, staticRenderFns } from "./ProcessedTask.vue?vue&type=template&id=138fbf11&scoped=true"
import script from "./ProcessedTask.vue?vue&type=script&lang=js"
export * from "./ProcessedTask.vue?vue&type=script&lang=js"
import style0 from "./ProcessedTask.vue?vue&type=style&index=0&id=138fbf11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138fbf11",
  null
  
)

export default component.exports